import { DateTime } from 'luxon'

import { Contract, ContractTenant } from '../../../../common/validations'

// Returns true if at least one tenant's contract ends earlier than the main contract's end date
export const hasActiveTermination = (
  contract: Contract,
  tenants: ContractTenant[]
) => {
  if (contract.isFixedTerm && contract.endDate) {
    const contractEnd = DateTime.fromISO(contract.endDate).startOf('day')

    return tenants.some(
      (tenant) =>
        tenant.endDate &&
        DateTime.fromISO(tenant.endDate).startOf('day') < contractEnd
    )
  }

  return tenants.some((tenant) => !!tenant.endDate)
}
